const actions = {
  SET_STATE: 'settings/SET_STATE',
  HANDLE_STATE: 'settings/HANDLE_STATE',
  CHANGE_SETTING: 'settings/CHANGE_SETTING',
  CATEGORY: 'settings/CATEGORY',
}

export default actions
